import * as React from 'react';
import styled from 'styled-components';//emotion:chakuraUI(型付与)
import { useTranslation } from 'react-i18next';

import jsQR, { QRCode } from "jsqr";
import * as ethers from 'ethers';
import { QRLocation } from 'jsqr/dist/locator';

type Props = {
    onClickFlagStatus:boolean,
    setOnClickFlagStatus:any,
    videoRef:React.MutableRefObject<HTMLVideoElement>,
    canvasRef:React.MutableRefObject<HTMLCanvasElement>,
    // languageExchange:any,
}
export const RecoveryBackupCardButton: React.FC<Props> = (props) => {
  const [count, setCount] = React.useState(0);
  const [delay, setDelay] = React.useState(250);//秒間
  const [t, i18n] = useTranslation();

  const RecoveryBackupCardButtonDiv = styled.div`
    justify-content: center;
    display: flex;
  `;
  const RecoveryBackupCardButtonComponent = styled.p`
    color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 4px 24px;
    gap: 10px;
    width: 80%;
    height: 37px;
    background: #41C6BF;
    border: 1px solid #20a2a2;
    border-radius: 40px;
    flex: none;
    order: 3;
    align-self: stretch;
    flex-grow: 0;
    margin: 0;
    margin-top: 10px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  `;

  function onClick() {
    props.setOnClickFlagStatus(true);
  }

  //WEB上カメラ起動
  React.useEffect(()=>{
    (async() => {
      if (props.onClickFlagStatus) {
        navigator.mediaDevices
        .getUserMedia({
            audio: false,
            video: {    
                facingMode: {
                    exact: 'environment'
                }
            }
        })
        .then(function(stream) {
            props.videoRef.current.srcObject = stream;
            props.videoRef.current.onloadedmetadata = function(e) {
                props.videoRef.current.play();
            }
            // window.scrollTo(0,1000);
        })
        .catch(function(err) {
            // alert('Error!! スマートフォンに対応しています');
            alert(t('エラー!! スマートフォンに対応しています'));
        })

      }
    })()
  },[]);
  
  //QRコード読み取り
  React.useEffect(()=>{
    if(!props.onClickFlagStatus){return;}
    let cameraIntervalId = setInterval(()=>{

      const context = props.canvasRef.current.getContext('2d');
      const msg:HTMLElement = document.querySelector("#debugmes");

      //⏬実行部分
      if(props.videoRef.current.readyState === props.videoRef.current.HAVE_ENOUGH_DATA){
          props.canvasRef.current.height = props.videoRef.current.videoHeight;
          props.canvasRef.current.width = props.videoRef.current.videoWidth;
          context.drawImage(props.videoRef.current, 0, 0, props.canvasRef.current.width, props.canvasRef.current.height);
          let img = context.getImageData(0, 0, props.canvasRef.current.width, props.canvasRef.current.height);
          let code = jsQR(img.data, img.width, img.height, {inversionAttempts: "dontInvert"});

          if(code){

              const walletaddress = new ethers.Wallet(code.data.split("pkey=")[1]).address;
              localStorage.setItem("privateKey",code.data.split("pkey=")[1]);
              localStorage.setItem("walletAddressFromPK",walletaddress);
              msg.innerText = "次のアドレスが復旧されました   "+walletaddress;// Data
              alert("次のアドレスが復旧されました \n"+walletaddress);
              clearInterval(cameraIntervalId);
              setTimeout(()=>{
                  //👇スクロール関数が効いていない原因
                  location.reload();
              },2500);
          }else{
              msg.innerText = "Detecting QR-Code...";
          }
      }
    } , delay);
    return () => clearInterval(cameraIntervalId);
  },[]);
  return (
    <RecoveryBackupCardButtonDiv id="recoverybackupcarddiv">
        <RecoveryBackupCardButtonComponent id="recoverybackupcard" onClick={onClick}>{t('カードをカメラで読取り復旧')}</RecoveryBackupCardButtonComponent>
    </RecoveryBackupCardButtonDiv>
  );
};